import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { MaterialGradeParams } from '../material-grade.component';

@Component({
    selector: 'tt-material-grade-view',
    templateUrl: './material-grade-view.component.html',
    styleUrls: ['./material-grade-view.component.css'],
})
export class MaterialGradeViewComponent {
    public heading = '';

    public params: MaterialGradeParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as MaterialGradeParams;
    }

    onSubmit() {
        this.state.back();
    }
}
